export const enum branchConstants {
  enableBranchesRequest = "ENABLE_BRANCHES_REQUEST",
  enableBranchesSuccess = "ENABLE_BRANCHES_SUCCESS",
  enableBranchesFailure = "ENABLE_BRANCHES_FAILURE",

  createBranchRequest = "CREATE_BRANCH_REQUEST",
  createBranchSuccess = "CREATE_BRANCH_SUCCESS",
  createBranchFailure = "CREATE_BRANCH_FAILURE",

  listBranchesRequest = "LIST_BRANCHES_REQUEST",
  listBranchesSuccess = "LIST_BRANCHES_SUCCESS",
  listBranchesFailure = "LIST_BRANCHES_FAILURE",

  switchTenantRequest = "SWITCH_TENANT_REQUEST",
  switchTenantSuccess = "SWITCH_TENANT_SUCCESS",
  switchTenantFailure = "SWITCH_TENANT_FAILURE",
}
